import styled, { css } from 'styled-components/macro'

export const Section = styled.section`
  margin: 0 auto;
  padding: 3.2rem 1.6rem;
  width: 100%;
  max-width: 63.2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  ${(props) => props.theme.breakpoints.greaterThan('sm')`
    padding: 5.4rem 3.2rem;
    max-width: 66.4rem;
  `};
`

export const ErrorsWrap = styled.div`
  margin: 0 0 0.8rem;
  min-height: 4.1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.8rem;
`

export const ButtonsWrap = styled.div<{ isDuplicates?: boolean }>`
  padding: 0;
  width: 100%;
  max-width: 28.6rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3.2rem;
  ${(props) =>
    props.isDuplicates &&
    css`
      max-width: 60rem;
    `}
  ${(props) => props.theme.breakpoints.greaterThan('sm')`
    flex-direction: row;
  `};
`

export const ActionButtonWrap = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
`
